import API from "../services/api";

const digitsOnly = (val) => String(val || "").replace(/\D/g, "");

export const normalizeWhatsAppNumber = (raw, defaultCountryCode = "+91") => {
  const cc = digitsOnly(defaultCountryCode) || "91";
  const digits = digitsOnly(raw);
  if (!digits) return "";
  if (digits.length === 10) return `${cc}${digits}`;
  if (digits.length === 11 && digits.startsWith("0")) return `${cc}${digits.slice(1)}`;
  if (digits.startsWith(cc) && digits.length >= cc.length + 8) return digits;
  return digits.length >= 8 ? digits : "";
};

export const buildWhatsAppUrl = (phone, message = "", defaultCountryCode = "+91") => {
  const num = normalizeWhatsAppNumber(phone, defaultCountryCode);
  if (!num) return "";
  const text = String(message || "").trim();
  return text ? `https://wa.me/${num}?text=${encodeURIComponent(text)}` : `https://wa.me/${num}`;
};

export const sendPortalWhatsApp = async ({
  to,
  recipientName = "",
  message = "",
  templateId = "",
  templateVariables,
  chooseTemplate = true,
  sourceModule = "manual_button",
  eventType = "manual_message",
  entityType = "",
  entityId = "",
  isAdmin = false,
  media,
  buttons,
  metaData,
}) => {
  const endpoint = isAdmin ? "/admin/whatsapp/send" : "/employee/whatsapp/send";
  let selectedTemplateId = String(templateId || "").trim();

  if (!selectedTemplateId && chooseTemplate && typeof window !== "undefined") {
    const templateEndpoint = isAdmin ? "/admin/whatsapp/templates" : "/employee/whatsapp/templates";
    try {
      const res = await API.get(templateEndpoint);
      const list = Array.isArray(res.data?.templates) ? res.data.templates : [];
      if (list.length) {
        const menu = list
          .map((t, i) => `${i + 1}. ${t.label || t.name || t.templateId} (${t.templateId})`)
          .join("\n");
        const defaultChoice = Math.max(1, list.findIndex((t) => t.isDefault) + 1 || 1);
        const input = window.prompt(`Select WhatsApp Template:\n${menu}\n\nEnter number or template id:`, String(defaultChoice));
        if (input == null) {
          const err = new Error("Template selection cancelled");
          err.isTemplateCancelled = true;
          err.response = { data: { message: "Template selection cancelled" } };
          throw err;
        }
        const raw = String(input).trim();
        const idx = Number(raw);
        if (Number.isInteger(idx) && idx >= 1 && idx <= list.length) {
          selectedTemplateId = String(list[idx - 1].templateId || "").trim();
        } else {
          selectedTemplateId = raw;
        }
      }
    } catch (e) {
      if (e?.isTemplateCancelled) throw e;
      // ignore template fetch error and fallback to default template at server side
    }
  }

  return API.post(endpoint, {
    to,
    recipientName,
    message,
    templateId: selectedTemplateId || undefined,
    templateVariables,
    sourceModule,
    eventType,
    entityType,
    entityId,
    media,
    buttons,
    metaData,
  });
};
